<template>
    <span v-if="itemId">
        <b-button
            class="align-baseline"
            title="Resync"
            variant="link"
            @click="checkStaleBeforeResync"
            v-if="!deleted && !isSynchronizing"
        >
            <font-awesome-icon 
                :icon="['fas', 'arrows-rotate']"
                :spin="isSpinning"
            ></font-awesome-icon>
        </b-button>
    </span>
    <modal
        title="Confirm Forced Sync"
        :id="confirmModalId"
        @ok="forceResyncItem"
        >
        <p>
            This object is stale and may not reflect the latest data. A forced resync will attempt to update it. In some cases, it might combine
            line items from both QuickBooks and Lodgix transactions.
        </p>
        <p>
            Please manually review the line items afterward to ensure accuracy and avoid duplicates.
        </p>
        <p>
            Are you sure you want to force resync?
        </p>
    </modal>    
</template>

<script>
import { mapGetters } from 'vuex';
import API from '../../api';
import capitalize from 'lodash/capitalize';
import { formatResponseError } from '../../utils/api';
import Modal from '../generic/modal/modal.vue';
import { QUICKBOOKS_OBJECTS_ENDPOINT } from '../../endpoints';

export default {
    components: {
        Modal,
    },
    computed: {
        ...mapGetters('quickbooks', ['isSynchronizing']),
        isStale() {
            return this.params.data.last_error?.includes('Stale Object Error');
        },
        confirmModalId() {
            return 'confirm-modal-' + this.params.data.id;
        },
    },
    data() {
        return {
            itemId: 0,
            deleted: false,
            isSpinning: false,
        };
    },
    created() {
        this.itemId = this.params.data && this.params.data.id;
        this.deleted = this.params.data && this.params.data.deleted;
    },
    methods: {
        checkStaleBeforeResync() {
            if (this.isStale) {
                this.$bvModal.show(this.confirmModalId);
            } else {
                this.handleResyncItem(false);
            }
        },
        forceResyncItem() {
            this.handleResyncItem(true);
        },
        handleResyncItem(force) {
            this.resync({ data: this.params.data, node: this.params.node }, force);
        },
        async resync({ data, node }, force) {
            //this.isSpinning = true;
            this.params.setBusy(true);
            const objType = data.type.toLowerCase();
            try {
                const response = await API.post(`${QUICKBOOKS_OBJECTS_ENDPOINT(objType, data.id)}/synchronize/`, {
                    force: force,
                });
                node.setData(response.data);
                if (response.data.last_error === null) {
                    this.successToast({
                        text: capitalize(objType) + ' successfully synchronized',
                    });
                } else {
                    this.errorToast({
                        text: response.data.last_error,
                    });
                }
            } catch (error) {
                console.log(error);
                const { generic } = formatResponseError(error);
                this.errorToast({
                    text: generic || `Could not synchronize ${objType}.`,
                });
                return;
            } finally {
                this.params.refresh(data.invoice_id, data.type);
                this.params.setBusy(false);
                //this.isSpinning = false;
            }
        },
    },
};
</script>
